module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_transportation-06760331.png";